import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';

import storage from 'redux-persist/lib/storage';
import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import thunk from 'redux-thunk';

import {paylogikApi} from '../rtkquery/paylogikApi';
import invoiceResearchReducer from './invoiceresearchSlice';
import authReducer from './authSlice';
import LogRocket from 'logrocket';
import carrierAdminReducer from './carrierAdminSlice';
import customerAdminReducer from './customerAdminSlice';

const reducers = combineReducers({
    [paylogikApi.reducerPath]: paylogikApi.reducer,
    invoiceresearch: invoiceResearchReducer,
    carrierAdmin: carrierAdminReducer,
    customerAdmin: customerAdminReducer,
    auth: authReducer,
});

export const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['api'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(paylogikApi.middleware)
            .concat(LogRocket.reduxMiddleware()),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
